import React, { useState } from 'react';

const MerchantRegistrationTest = () => {
  const [loading, setLoading] = useState(false);
  const [response, setResponse] = useState(null);
  const [error, setError] = useState(null);

  const testAPI = async () => {
    setLoading(true);
    setError(null);
    setResponse(null);

    try {
      // Create a simple test form data
      const formData = new FormData();
      
      // Add basic merchant data
      formData.append('business_name', 'متجر الاختبار');
      formData.append('legal_name', 'الاسم القانوني للاختبار');
      formData.append('cr_number', '1234567890');
      formData.append('contact_person', 'أحمد محمد');
      formData.append('phone', '+966501234567');
      formData.append('email', 'test@example.com');
      formData.append('address', 'شارع الملك فهد، الرياض');
      formData.append('city', 'الرياض');
      formData.append('business_category', 'restaurant');

      // Add simple offers data as individual form fields
      formData.append('offers[0][offer_title]', 'عرض الاختبار');
      formData.append('offers[0][offer_description]', 'وصف العرض');
      formData.append('offers[0][discount_percentage]', '10');
      formData.append('offers[0][valid_from]', '2024-01-01');
      formData.append('offers[0][valid_until]', '2024-12-31');
      formData.append('offers[0][max_uses]', '100');
      formData.append('offers[0][min_wallet_balance]', '50');
      
      // Add products for the offer (skip image_url if empty)
      formData.append('offers[0][products][0][product_name]', 'منتج الاختبار');
      formData.append('offers[0][products][0][description]', 'وصف المنتج');
      formData.append('offers[0][products][0][original_price]', '100');
      formData.append('offers[0][products][0][category]', 'طعام');
      formData.append('offers[0][products][0][stock_quantity]', '10');
      // Skip image_url since it's empty
      formData.append('gallery_metadata', JSON.stringify([]));

      console.log('🧪 Testing API with data:');
      for (let [key, value] of formData.entries()) {
        console.log(`${key}:`, value);
      }

      const response = await fetch('https://nodjswebhook.onrender.com/api/public/merchant-registration', {
        method: 'POST',
        body: formData
      });

      console.log('📡 Response status:', response.status);
      console.log('📡 Response headers:', response.headers);

      let result;
      try {
        result = await response.json();
        console.log('📡 Response data:', result);
      } catch (parseError) {
        console.error('❌ Error parsing response:', parseError);
        setError('خطأ في تحليل استجابة الخادم');
        return;
      }

      if (response.ok && result.success) {
        setResponse(result);
      } else {
        console.error('❌ API Error:', result);
        const errorMessage = result.error || result.message || `خطأ في الخادم (${response.status})`;
        setError(errorMessage);
      }
    } catch (err) {
      console.error('Error testing API:', err);
      setError('خطأ في الاتصال: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-4 border rounded-lg shadow-sm dark:bg-gray-800 dark:border-gray-700">
      <h3 className="text-lg font-semibold mb-4 dark:text-gray-100">
        🧪 اختبار API تسجيل التجار
      </h3>
      
      <button
        onClick={testAPI}
        disabled={loading}
        className="px-4 py-2 bg-blue-600 text-white font-medium rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 dark:focus:ring-offset-gray-800 disabled:opacity-50"
      >
        {loading ? 'جاري الاختبار...' : 'اختبار API'}
      </button>

      {response && (
        <div className="mt-4 p-3 bg-green-100 text-green-800 rounded-md dark:bg-green-900 dark:text-green-200">
          <p className="font-semibold">✅ نجح الاختبار:</p>
          <pre className="whitespace-pre-wrap text-sm">{JSON.stringify(response, null, 2)}</pre>
        </div>
      )}

      {error && (
        <div className="mt-4 p-3 bg-red-100 text-red-800 rounded-md dark:bg-red-900 dark:text-red-200">
          <p className="font-semibold">❌ فشل الاختبار:</p>
          <pre className="whitespace-pre-wrap text-sm">{error}</pre>
        </div>
      )}
    </div>
  );
};

export default MerchantRegistrationTest;
